// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

export const allFeatures = {
	SystemAdminCustomers:"SystemAdminCustomers",
	CustomerAdmin:"CustomerAdmin",
	News:"News",
	Learning:"Learning",
	SystemAdminLearning:"SystemAdminLearning",
	SystemAdminDeviceRegistry:"SystemAdminDeviceRegistry",
	Map:"Map",
	VehicleRegistry:"VehicleRegistry",
	VehicleRegistry_Alarms:"VehicleRegistry_Alarms",
	SystemEvents:"SystemEvents",
	Planning:"Planning",
	IssueReports:"IssueReports",
	Assembly:"Assembly",
	PartnerCustomers:"PartnerCustomers",
	Documents:"Documents",
	Payslips:"Payslips",
	Deviation:"Deviation",
	CrisisManagement:"CrisisManagement",
	Violation:"Violation",
	Reports:"Reports",
	BkyChecks:"BkyChecks",
}
